import React , { useEffect , useState , useMemo } from 'react';

import { useGlobalContext } from '../../context/GlobalContext';

import { API_URL } from '../../../actions';

export default function Picture( { picture , size } ) {

  const [ path , setPath ] = useState(null)
  
  const [ context ] = useGlobalContext();

  useEffect(() => {
    if (!picture) {
      setPath(null);
      return;
    }

    const imageId = picture?._id || picture;
    const imgFound = context.medias.mediasList?.find(item => item._id === imageId);

    if (imgFound?.path) {
      setPath(API_URL + '/' + imgFound.path);
    } else if (picture?.path) {
      setPath(API_URL + '/' + picture.path);
    } else {
      setPath(null);
    }
    // eslint-disable-next-line
  }, [picture, context.medias.mediasList])

  return useMemo(() => (
    <>
      {path && <img src={path} alt="approach" className="img-large"/>}
    </>
  ), [path]);
}
